import { Calendar } from 'vanilla-calendar-pro';
import 'vanilla-calendar-pro/styles/index.css';

const container = document.getElementById('calendar');
if (container) {
  const lang = container.getAttribute('data-lang') || 'en';
  const dateMin = container.getAttribute('data-date-min');
  const dateMax = container.getAttribute('data-date-max');
  const popups = JSON.parse(container.getAttribute('data-events') || '');

  const calendar = new Calendar(container, {
    type: 'multiple',
    firstWeekday: 0,
    locale: lang,
    displayMonthsCount:
      document.body.clientWidth > 599 && document.body.clientWidth < 993
        ? 2
        : 3,
    dateMin,
    dateMax,
    popups
  });

  calendar.init();

  window.addEventListener('resize', () => {
    calendar.set({
      displayMonthsCount:
        document.body.clientWidth > 599 && document.body.clientWidth < 993
          ? 2
          : 3
    });
  });
}
